export const SIGN_TYPE_TAG = {
  RADICAL: { title: "Radical", value: "radical" },
  CHARACTER: { title: "Character", value: "character" },
  WORD_EXPRESSION: { title: "Word or expression", value: "word_expression" },
};
